export enum ModalVariantCommonE {
  CONFIRM = 'CONFIRM',
  IMAGE_PREVIEW = 'IMAGE_PREVIEW',
  CHANGE_NETWORK_MODAL = 'CHANGE_NETWORK_MODAL',
}
